// Iter 186 — 👤 Espace Adhérent : lien magique permanent par email.
// Sans token : formulaire de demande. Avec token : toutes les fiches du voyageur.
import React, { useState, useEffect, useCallback, useRef } from 'react';
import SpamNotice from '../components/SpamNotice';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import ExcursionsBlock from '../components/ExcursionsBlock';
import { SondageVote } from './SondagePage';
import FicheInfosBlock from '../components/FicheInfosBlock';
import AssistantChat from '../components/AssistantChat';
import InstallAppBlock from '../components/InstallAppBlock';
import MonRendezVous from '../components/MonRendezVous';
import axios from 'axios';
import { sauverEspaceToken, lireEspaceToken, oublierEspaceToken, precacherPhotos } from '../utils/espaceMemoire';
import { Accordeon, Rubrique } from '../components/espace/Rubriques';
import FicheVoyage from '../components/espace/FicheVoyage';
import { BandeauQrDepart, ficheQrImminente } from '../components/espace/QrEmbarquement';
import ReglementsDistance from '../components/espace/ReglementsDistance';
import { Euros, ChecklistDepart, joursAvantDepart } from '../components/espace/BlocsFiche';
import { useEspaceTextes } from '../hooks/useFormTextes';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ESPACE_TOKEN_KEY = 'raav_espace_token';


// Iter 311 — rubrique dépliable/repliable (avec bouton « Replier » aussi EN BAS,
// pour ne pas obliger à remonter la page — pensé pour les moins à l'aise avec l'informatique).

// Iter 228 (Kamel) — Croissance : mini-catalogue, diffusion, partage, fidélité.
const fmtDateFr = (iso) => {
  try { return new Date(iso + 'T00:00:00').toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }); } catch { return iso; }
};

const ProchainsVoyages = ({ voyages, diffusionInscrit, token }) => {
  const [inscrit, setInscrit] = useState(diffusionInscrit);
  const [busy, setBusy] = useState(false);
  const rejoindre = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/espace-adherent/${token}/diffusion`);
      setInscrit(true);
    } catch (e) { alert('Erreur : ' + (e.response?.data?.detail || e.message)); }
    setBusy(false);
  };
  // Iter 234 (Kamel) — Partage d'un voyage précis (compte pour les trophées).
  const partagerVoyage = (v) => {
    axios.post(`${API}/espace-adherent/${token}/partage`, { canal: 'voyage' }).catch(() => {});
    const detail = [v.start_date ? `départ le ${fmtDateFr(v.start_date)}` : '', v.price_from ? `à partir de ${v.price_from} €` : ''].filter(Boolean).join(', ');
    const msg = encodeURIComponent(
      `Regarde ce voyage avec Rhône Alpes Amitié Voyages : ${v.title}${detail ? ` (${detail})` : ''} 🌍\n${window.location.origin}/voyage/${v.id}\n\nJe voyage avec eux, c'est une association lyonnaise vraiment sympa ! 👋`);
    window.open(`https://api.whatsapp.com/send/?text=${msg}`, '_blank');
  };
  return (
    <div className="space-y-3" data-testid="espace-prochains-voyages">
      {voyages.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {voyages.map(v => (
            <div key={v.id} className="rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow flex flex-col"
              data-testid={`prochain-voyage-${v.id}`}>
              <a href={`/voyage/${v.id}`} target="_blank" rel="noopener noreferrer" className="block flex-1">
                {v.image_url && <img src={v.image_url} alt={v.title} className="w-full h-24 object-cover" />}
                <div className="p-2.5">
                  <p className="text-xs font-bold text-[#1E3A5F] leading-tight">{v.title}</p>
                  <p className="text-[10px] text-gray-500 mt-1">
                    {v.start_date && <>🗓 {fmtDateFr(v.start_date)}{v.duration_days ? ` · ${v.duration_days} j` : ''}<br /></>}
                    {v.price_from && <span className="font-bold text-[#5BC5D4]">À partir de {v.price_from} €</span>}
                  </p>
                </div>
              </a>
              <button onClick={() => partagerVoyage(v)} data-testid={`partager-voyage-${v.id}`}
                className="w-full text-[10px] font-bold py-1.5 bg-[#25D366]/10 text-[#128C46] hover:bg-[#25D366]/20 border-t border-gray-100">
                💬 Faire découvrir ce voyage
              </button>
            </div>
          ))}
        </div>
      )}
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs text-amber-900 font-bold">🔔 Ne ratez aucun nouveau voyage</p>
        {inscrit ? (
          <span className="text-xs font-bold text-emerald-700" data-testid="espace-diffusion-ok">✅ Vous êtes sur la liste de diffusion !</span>
        ) : (
          <button onClick={rejoindre} disabled={busy} data-testid="espace-diffusion-btn"
            className="text-xs font-bold px-3.5 py-1.5 rounded-lg bg-[#1E3A5F] text-white hover:bg-[#2a4d7a] disabled:opacity-40">
            {busy ? '…' : 'Me prévenir des prochains voyages'}
          </button>
        )}
      </div>
    </div>
  );
};

const PartagerRAAV = ({ token, partage }) => {
  const origin = window.location.origin;
  const [info, setInfo] = useState(partage || { total: 0 });
  const track = async (canal) => {
    try {
      const r = await axios.post(`${API}/espace-adherent/${token}/partage`, { canal });
      setInfo({ total: r.data.total, trophee: r.data.trophee, prochain: r.data.prochain });
    } catch { /* silencieux */ }
  };
  const msg = encodeURIComponent(`Coucou ! 👋 Je voyage avec Rhône Alpes Amitié Voyages, une association lyonnaise vraiment sympa (Espagne, Thaïlande, sorties à la journée…). Va voir leurs voyages : ${origin} 🌍✈️`);
  const mailBody = encodeURIComponent(`Bonjour,\n\nJe voyage avec Rhône Alpes Amitié Voyages, une association lyonnaise que je te recommande (Espagne, Thaïlande, sorties à la journée…).\n\nDécouvre leurs voyages ici : ${origin}\n\nÀ bientôt !`);
  return (
    <div className="bg-gradient-to-br from-[#FFC400]/20 to-[#FFD640]/10 border border-[#FFC400]/40 rounded-xl p-3 text-center space-y-2" data-testid="espace-partager-block">
      <p className="text-xs text-gray-600">Faites découvrir <strong>Rhône Alpes Amitié Voyages</strong> à vos proches — le bouche-à-oreille est notre meilleur moteur !</p>
      <div className="flex flex-wrap justify-center gap-2">
        <a href={`https://api.whatsapp.com/send/?text=${msg}`} target="_blank" rel="noopener noreferrer" onClick={() => track('whatsapp')}
          className="inline-flex items-center gap-1.5 text-xs font-bold px-4 py-2 rounded-xl bg-[#25D366] text-white hover:opacity-90"
          data-testid="espace-partager-whatsapp">
          💬 Partager par WhatsApp
        </a>
        <a href={`mailto:?subject=${encodeURIComponent('Découvre Rhône Alpes Amitié Voyages !')}&body=${mailBody}`} onClick={() => track('email')}
          className="inline-flex items-center gap-1.5 text-xs font-bold px-4 py-2 rounded-xl bg-[#1E3A5F] text-white hover:bg-[#2a4d7a]"
          data-testid="espace-partager-email">
          ✉️ Partager par email
        </a>
      </div>
      <div className="bg-white/70 rounded-xl px-3 py-2 space-y-0.5" data-testid="espace-trophee-block">
        {info.trophee ? (
          <p className="text-xs font-bold text-amber-700" data-testid="espace-trophee-actuel">
            {info.trophee.emoji} Vous êtes <strong>{info.trophee.nom}</strong> ({info.total} partage{info.total > 1 ? 's' : ''}) !
          </p>
        ) : (
          <p className="text-xs font-bold text-gray-600">🏅 Trophées de partage : Bronze 🥉 · Argent 🥈 · Or 🥇 · Légende 🏆</p>
        )}
        {info.prochain && (
          <p className="text-[11px] text-gray-600" data-testid="espace-trophee-prochain">
            Plus que <strong>{info.prochain.restant}</strong> partage{info.prochain.restant > 1 ? 's' : ''} pour devenir {info.prochain.emoji} <strong>{info.prochain.nom}</strong> !
          </p>
        )}
        <p className="text-[10px] text-gray-400 italic">Aucune promesse, juste notre reconnaissance — l'association a toujours su remercier ceux qui la font grandir 😉</p>
      </div>
    </div>
  );
};

const GUIDE_ETAPES = [
  ['💰', 'Vos paiements en un coup d\'œil', 'Chaque voyage affiche ce qui est payé, le reste à régler et vos factures PDF.'],
  ['✏️', 'Vérifiez vos informations', 'Cliquez sur « Vérifier / modifier mes informations » pour corriger vous-même téléphone, email, nom…'],
  ['📘', 'Tous vos documents', 'Descriptif du voyage, convocation de départ, garanties assurance et conditions générales — toujours à jour.'],
  ['🔔', 'Activez les notifications', 'Recevez les rappels de paiement, horaires et infos de départ directement sur votre téléphone.'],
  ['🔖', 'Votre espace est mémorisé ici', 'Cet appareil se souvient de votre espace : revenez sur le site (ou ouvrez l\'appli installée), il s\'ouvre directement — sans email ni lien !'],
  ['📱', 'Sur iPhone/iPad : le code à 6 chiffres', 'Depuis l\'appli installée, tapez votre email puis le code à 6 chiffres reçu par email : votre espace s\'ouvre dans l\'appli et y reste mémorisé — plus jamais besoin de vous reconnecter.'],
];

const GuideBienvenue = ({ onClose, T }) => (
  <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" data-testid="guide-bienvenue-overlay">
    <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
      <div className="bg-[#1E3A5F] text-white rounded-t-2xl p-5 text-center">
        <p className="text-3xl">👋</p>
        <h2 className="text-xl font-bold mt-1">{T('guide_titre')}</h2>
        <p className="text-xs text-[#79c9ea] mt-1">{T('guide_sous_titre')}</p>
      </div>
      <div className="p-5 space-y-3">
        {GUIDE_ETAPES.map(([ico, titre, texte], i) => (
          <div key={i} className="flex gap-3 items-start" data-testid={`guide-etape-${i}`}>
            <span className="text-xl flex-shrink-0 w-9 h-9 rounded-full bg-sky-50 border border-sky-100 flex items-center justify-center">{ico}</span>
            <div>
              <p className="text-sm font-bold text-[#1E3A5F]">{titre}</p>
              <p className="text-xs text-gray-600">{texte}</p>
            </div>
          </div>
        ))}
        <button onClick={onClose} data-testid="guide-bienvenue-fermer"
          className="w-full py-3 bg-[#1E3A5F] text-white font-bold rounded-xl hover:bg-[#2a4d7a]">
          {T('guide_bouton')}
        </button>
      </div>
    </div>
  </div>
);

// Iter 297 — 🤝 Charte de bienvenue « On la joue collectif ou pas ? » (Kamel)
// Iter 298 — ✍️ « Lu et approuvé » facultatif + petit rappel tant que pas signé.
const CharteCollectif = ({ token, approuveeAt, onApprouvee }) => {
  const [busy, setBusy] = useState(false);
  const approuver = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/espace-adherent/${token}/charte-approbation`);
      onApprouvee(r.data.at);
    } catch { /* réessaiera plus tard */ }
    setBusy(false);
  };
  return (
  <details className="bg-white rounded-xl shadow border-2 border-[#1E3A5F] overflow-hidden" data-testid="espace-charte-collectif">
    <summary className="cursor-pointer select-none px-4 py-3 font-bold text-sm text-[#1E3A5F] bg-blue-50 hover:bg-blue-100">
      🤝 On la joue collectif ou pas ? <span className="font-normal text-xs text-gray-500">— le cadre de vie commune, à lire avant le départ</span>
      {approuveeAt
        ? <span className="block text-[11px] font-bold text-emerald-700 mt-0.5" data-testid="espace-charte-approuvee">✅ Lu et approuvé le {new Date(approuveeAt).toLocaleDateString('fr-FR')} — merci !</span>
        : <span className="block text-[11px] font-bold text-amber-700 mt-0.5" data-testid="espace-charte-rappel">😉 Oui oui… vous n'avez pas encore signé la charte ! Un petit « Lu et approuvé » et on n'en parle plus.</span>}
    </summary>
    <div className="px-4 py-3 text-[13px] text-gray-700 space-y-3 leading-relaxed" data-testid="espace-charte-contenu">
      <p className="font-bold text-center text-[#1E3A5F]">🌟 BIENVENUE DANS L'AVENTURE RHÔNE ALPES AMITIÉ VOYAGES ! 🌟</p>
      <p>Toute l'équipe est ravie de vous accueillir ! Pour que ce voyage soit une réussite collective, merci de lire attentivement ce cadre de vie commune :</p>
      <div>
        <p className="font-bold text-[#1E3A5F]">🤝 L'Esprit Associatif & Respect</p>
        <p>Nous sommes une association, pas une agence classique. Notre équipe se dévoue pour vous offrir les vacances les moins chères de France. En retour, nous exigeons un <strong>respect total</strong> envers les organisateurs et les autres voyageurs. Cela passe aussi par une <strong>ponctualité exemplaire</strong> lors des départs et des rendez-vous : respecter l'horaire, c'est respecter tout le groupe.</p>
      </div>
      <div>
        <p className="font-bold text-[#1E3A5F]">✨ Le bon état d'esprit</p>
        <p>✅ <strong>OUI à la Patience :</strong> dans un grand groupe, un peu d'attente est parfois inévitable.</p>
        <p>❌ <strong>NON aux Exigences déplacées :</strong> nous ne sommes pas à votre service exclusif.</p>
        <p>✅ <strong>OUI à l'Adhérent acteur :</strong> soyez acteur de votre voyage !</p>
        <p>❌ <strong>NON au Clientélisme :</strong> ne traitez pas les organisateurs comme des employés. Si vous cherchez un service de conciergerie privée, vous n'êtes pas au bon endroit. Ici, nous privilégions la relation humaine et la responsabilité de chacun.</p>
      </div>
      <div>
        <p className="font-bold text-[#1E3A5F]">👥 Grands Groupes & Responsabilité</p>
        <p>Nous gérons des groupes très importants. <strong>Chaque voyageur est responsable de la lecture des informations transmises.</strong> Nous ne pouvons pas être partout pour répéter ce qui est déjà écrit. Votre autonomie et votre attention sont les clés de la réussite.</p>
      </div>
      <div>
        <p className="font-bold text-[#1E3A5F]">🏨 Hôtel & Chambres</p>
        <p>L'association n'intervient pas dans la <strong>distribution des chambres</strong>, qui relève de l'hôtel. Elles sont prêtes <strong>à partir de 15h</strong>. Pour tout souci technique ou demande sur place, adressez-vous <strong>directement à la réception</strong>.</p>
      </div>
      <div>
        <p className="font-bold text-[#1E3A5F]">📱 Outils Numériques</p>
        <p>Pour vos factures, horaires et documents, utilisez votre <strong>Espace Adhérent</strong> ou le site <strong>www.rhoneamitievoyages.fr</strong>. Tout y est centralisé pour vous simplifier la vie !</p>
      </div>
      <div>
        <p className="font-bold text-[#1E3A5F]">🧭 Je suis responsable de mes vacances</p>
        <p>Chacun est <strong>acteur et responsable de ses propres vacances</strong> : je lis les informations, je respecte les horaires et les procédures, je prépare mes documents et je m'organise. L'équipe est là pour encadrer le groupe, pas pour se substituer à chacun.</p>
      </div>
      <div>
        <p className="font-bold text-[#1E3A5F]">🎶 Le mot de la fin</p>
        <p>« C'est à la fin du bal qu'on paie les musiciens. » Tout n'est peut-être pas parfait à chaque instant, mais notre seul objectif est que vous passiez de <strong>bonnes vacances</strong>. Profitez du soleil, de l'ambiance et du groupe !</p>
      </div>
      <p className="font-bold text-right text-[#1E3A5F]">L'équipe Rhône Alpes Amitié Voyages 💙</p>
      {approuveeAt ? (
        <p className="text-center text-sm font-bold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2">
          ✅ Charte lue et approuvée le {new Date(approuveeAt).toLocaleDateString('fr-FR')} — merci de jouer collectif !
        </p>
      ) : (
        <div className="text-center">
          <p className="text-[12px] text-gray-600 bg-blue-50 border border-blue-200 rounded-lg px-3 py-2 mb-2 text-left" data-testid="espace-charte-declaration">
            En cliquant sur « Lu et approuvé », je déclare : <strong>je suis responsable de mes vacances</strong>, <strong>j'ai bien pris connaissance du fonctionnement et des procédures</strong>, et je m'engage au <strong>respect des organisateurs et des accompagnateurs</strong>.
          </p>
          <button onClick={approuver} disabled={busy} data-testid="espace-charte-approuver-btn"
            className="text-sm font-bold px-5 py-2.5 rounded-xl bg-[#1E3A5F] text-white hover:bg-[#2a4d7a] disabled:opacity-50">
            ✍️ Lu et approuvé — je joue collectif !
          </button>
          <p className="text-[11px] text-gray-400 mt-1">Facultatif, mais ça fait plaisir à toute l'équipe 💙</p>
        </div>
      )}
      <button onClick={(e) => { e.preventDefault(); e.target.closest('details').removeAttribute('open'); }}
        data-testid="espace-charte-replier-bas"
        className="w-full text-center text-xs font-bold text-[#1E3A5F] bg-gray-50 border border-gray-200 rounded-xl py-2.5 hover:bg-gray-100">
        ▴ Replier la charte
      </button>
    </div>
  </details>
  );
};

// Iter 222 (Kamel) — Bannière excursions si départ ≤ 14 jours ou séjour en cours (≤ 8 j après départ).
const ficheExcursionsProche = (fiches) => (fiches || []).find(f => {
  if (!f.excursions_dispo || f.statut === 'annulée') return false;
  const j = joursAvantDepart(f.date_depart);
  if (f.excursions_mode === 'voyage') return j !== null && j >= -30; // Iter 940 — circuit : choix bien avant le départ (date butoir)
  return j !== null && j <= 14 && j >= -8;
});

// Iter 459 — 📊 sondages ouverts pour cet adhérent (tous / ses voyages)
function SondagesEspace({ token }) {
  const [liste, setListe] = useState(null);
  useEffect(() => {
    axios.get(`${API}/espace-adherent/${token}/sondages`).then(r => setListe(r.data.sondages || [])).catch(() => setListe([]));
  }, [token]);
  if (!liste || liste.length === 0) return null;
  return (
    <div className="space-y-2 mb-3" data-testid="espace-sondages">
      <p className="text-xs font-bold text-[#1E3A5F]">📊 On a besoin de votre avis ({liste.length})</p>
      {liste.map(s => <SondageVote key={s.id} sondage={s} token={token} compact />)}
    </div>
  );
}

export default function EspaceAdherent() {
  const T = useEspaceTextes();
  const { token } = useParams();
  const navigate = useNavigate();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const veutRdv = params.get('rdv') === '1';      // Iter 535 — depuis la page Payer
  const veutPayer = params.get('payer') === '1';  // Iter 539 — après le formulaire d'inscription
  const veutNotes = params.get('notes') === '1';  // Iter 618 — lien direct vers « Mes notes de voyage »
  const voyageCible = params.get('voyage') || '';  // Iter 618 — destination à ouvrir (optionnel)
  const noteCible = params.get('note') || '';      // Iter 618 — note à déplier (optionnel)
  const bienvenue = params.get('bienvenue') === '1'; // Iter 551 — formulaire tout juste envoyé
  const apercu = params.get('apercu') === '1' || token?.startsWith('apercu-'); // Iter 553 — « Voir comme l'adhérent » (admin)
  const [ident, setIdent] = useState(params.get('email') || '');
  const [sent, setSent] = useState('');
  const [busy, setBusy] = useState(false);
  const [data, setData] = useState(null);
  const dataRef = useRef(null);
  useEffect(() => { dataRef.current = data; }, [data]);
  const [error, setError] = useState('');
  const [guide, setGuide] = useState(false);
  const [bloque, setBloque] = useState(false); // Iter 554 — aperçu admin : action refusée par le serveur (403)
  const [blocage, setBlocage] = useState(null); // Iter 591 — {code: 'en_reserve' | 'aucun_dossier', voyage, message}
  useEffect(() => {
    if (!apercu) return undefined;
    const id = axios.interceptors.response.use(undefined, (err) => {
      if (err.response?.status === 403 && String(err.response?.data?.detail || '').startsWith('👁')) { setBloque(true); setTimeout(() => setBloque(false), 3500); }
      return Promise.reject(err);
    });
    return () => axios.interceptors.response.eject(id);
  }, [apercu]);

  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/espace-adherent/${token}`);
      setData(r.data);
      setError('');
      if (r.data.premiere_visite && !bienvenue && !apercu) setGuide(true);
      if (!apercu) {
        sauverEspaceToken(token);
        try { localStorage.setItem(`espace_cache_${token}`, JSON.stringify({ at: Date.now(), data: r.data })); } catch { /* quota */ }
        precacherPhotos((r.data.fiches || []).flatMap(f => (f.notes_voyage || []).flatMap(n => (n.liens || []).filter(l => l.image).map(l => l.url))));
      }
    } catch (e) {
      const d = e.response?.data?.detail;
      const status = e.response?.status;
      // Iter 648 (Kamel) — pas de réseau / serveur injoignable : on NE déconnecte PAS (le lien reste mémorisé), on réessaie au retour du réseau.
      if (!e.response) {
        if (!dataRef.current) {
          let cache = null;
          try { cache = JSON.parse(localStorage.getItem(`espace_cache_${token}`) || 'null'); } catch { /* ignore */ }
          if (cache?.data) {
            setData(cache.data);  // dernière version connue : notes, convocation, programme restent lisibles hors ligne
            setError(`📶 Hors ligne — affichage de votre espace tel qu'il était le ${new Date(cache.at).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}. Il se mettra à jour tout seul au retour du réseau.`);
          } else {
            setError('📶 Pas de connexion internet pour le moment. Votre espace se rouvrira tout seul dès que le réseau revient — rien à refaire.');
          }
        }
        return;
      }
      // Iter 591 — 423 : dossier en réserve (ou supprimé) → espace fermé, la personne doit nous contacter
      if (status === 423 && d && typeof d === 'object') setBlocage(d);
      else setError((typeof d === 'object' && d?.message) || d || e.message);
      // on n'oublie le lien mémorisé QUE si le serveur dit qu'il n'est plus valable (lien expiré / révoqué / inconnu)
      if ([401, 404, 410].includes(status)) {
        try { if (localStorage.getItem(ESPACE_TOKEN_KEY) === token) oublierEspaceToken(); } catch { /* ignore */ }
      }
    }
  }, [token, bienvenue, apercu]);
  useEffect(() => { if (token) load(); }, [token, load]);
  // Iter 627 (Kamel — SLIMANI : convocation « bloquée » alors que soldée) : l'appli PWA reste ouverte des jours sur le
  // téléphone → données figées. On recharge dès que l'appli revient au premier plan (si > 60 s depuis le dernier chargement).
  const dernierLoad = useRef(Date.now());
  useEffect(() => {
    if (!token) return undefined;
    const refresh = (ev) => {
      if (document.visibilityState !== 'visible') return;
      if (Date.now() - dernierLoad.current < 60000 && !(ev?.type === 'online' && !dataRef.current)) return;
      dernierLoad.current = Date.now();
      load();
    };
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('focus', refresh);
    window.addEventListener('online', refresh);
    return () => { document.removeEventListener('visibilitychange', refresh); window.removeEventListener('focus', refresh); window.removeEventListener('online', refresh); };
  }, [token, load]);

  // Iter 539 — accordéons : UNE rubrique commune ouverte, UN voyage ouvert, UNE rubrique dans ce voyage.
  const [commun, setCommun] = useState(null);
  const [ficheOuverte, setFicheOuverte] = useState(null);
  const [rubriqueFiche, setRubriqueFiche] = useState(null);
  const fiches = data?.fiches || [];
  const aVenir = fiches.filter(f => f.statut === 'à venir');
  const resteTotal = aVenir.reduce((n, f) => n + (f.restant > 0 ? f.restant : 0), 0);
  useEffect(() => {
    if (!data) return;
    const cible = voyageCible && fiches.find(x => x.destination === voyageCible && x.statut !== 'annulée');
    const premier = cible || fiches.find(x => x.statut === 'à venir') || fiches[0];
    setFicheOuverte(premier?.reg_id || null);
    setCommun(veutRdv ? 'rdv' : veutPayer ? 'reglements' : null);
    if (veutNotes && premier) {
      setRubriqueFiche('notes');
      setTimeout(() => document.getElementById(noteCible ? `note-${noteCible}` : 'rubrique-notes')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 600);
    }
    if ((veutRdv || veutPayer) && !bienvenue) setTimeout(() => document.getElementById(`rubrique-${veutRdv ? 'rdv' : 'reglements'}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 600);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const ouvrirFiche = (regId, rub) => { setFicheOuverte(regId); setRubriqueFiche(rub || null); };
  const ouvrirCommun = (id) => { setCommun(id); setTimeout(() => document.getElementById(`rubrique-${id}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150); };
  // Iter 500 — « il vous reste N choses à cocher » → ouvre la bonne rubrique et y défile.
  const allerChecklist = useCallback((kind) => {
    if (kind === 'charte') { ouvrirCommun('charte'); return; }
    if (kind === 'rubriques') { // Iter 557 — 1re rubrique libre jamais ouverte
      const f = aVenir.find(x => (x.rubriques_perso || []).some(r => !r.vue_at));
      const r = f && (f.rubriques_perso || []).find(x => !x.vue_at);
      if (!r) return;
      ouvrirFiche(f.reg_id, `perso-${r.id}`);
      setTimeout(() => document.getElementById(`rubrique-perso-${r.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 250);
      return;
    }
    const f = aVenir.find(x => kind === 'notes' ? (x.notes_voyage || []).some(n => !n.lu_at) : (x.questions || []).some(q => (q.reponses || []).some(r => r.valeur == null || r.valeur === '' || r.valeur === false)));
    if (!f) return;
    ouvrirFiche(f.reg_id, kind);
    setTimeout(() => document.getElementById(`rubrique-${kind}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 250);
  }, [aVenir]); // eslint-disable-line react-hooks/exhaustive-deps
  const nbAChecker = (() => {
    if (!aVenir.length) return 0;
    const notes = aVenir.reduce((n, f) => n + (f.notes_voyage || []).filter(x => !x.lu_at).length, 0);
    const questions = aVenir.reduce((n, f) => n + (f.questions || []).reduce((m, q) => m + (q.reponses || []).filter(r => r.valeur == null || r.valeur === '' || r.valeur === false).length, 0), 0);
    const rubriques = aVenir.reduce((n, f) => n + (f.rubriques_perso || []).filter(r => !r.vue_at).length, 0);
    return notes + questions + rubriques + (data?.charte_approuvee_at ? 0 : 1);
  })();
  // Iter 557 — l'adhérent ouvre une rubrique libre → le badge « à cocher » se met à jour tout de suite
  const marquerRubriqueVue = useCallback((regId, rid) => setData(d => d ? { ...d, fiches: d.fiches.map(f => f.reg_id !== regId ? f : { ...f, rubriques_perso: (f.rubriques_perso || []).map(r => r.id === rid && !r.vue_at ? { ...r, vue_at: new Date().toISOString() } : r) }) } : d), []);

  // Iter 231 — l'appareil se souvient de l'espace.
  useEffect(() => {
    if (token) return;
    (async () => { const saved = await lireEspaceToken(); if (saved) navigate(`/espace-adherent/${saved}${search}`, { replace: true }); })();
  }, [token, navigate, search]);

  const [codeVal, setCodeVal] = useState('');
  const [codeBusy, setCodeBusy] = useState(false);
  const [codeErr, setCodeErr] = useState('');
  const [emailMasque, setEmailMasque] = useState('');
  const validerCode = async (e) => {
    e.preventDefault(); setCodeBusy(true); setCodeErr('');
    try {
      const r = await axios.post(`${API}/espace-adherent/code/verifier`, { identifiant: ident, code: codeVal });
      navigate(`/espace-adherent/${r.data.token}${search}`, { replace: true });
    } catch (err) { setCodeErr(err.response?.data?.detail || 'Code incorrect ou expiré.'); }
    setCodeBusy(false);
  };
  const demander = useCallback(async (e) => {
    e?.preventDefault(); setBusy(true);
    try {
      const r = await axios.post(`${API}/espace-adherent/demander`, { identifiant: ident });
      setSent(r.data.message); setEmailMasque(r.data.email_masque || '');
    } catch { setSent('Une erreur est survenue, réessayez dans un instant.'); }
    setBusy(false);
  }, [ident]);
  // Iter 539 — arrivée depuis le formulaire d'inscription : le code part tout seul.
  const autoDemande = React.useRef(false);
  useEffect(() => {
    if (token || !params.get('auto') || !ident || autoDemande.current) return;
    autoDemande.current = true; demander();
  }, [token, ident, demander]); // eslint-disable-line react-hooks/exhaustive-deps

  const [notif, setNotif] = useState(() => {
    if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) return 'unsupported';
    return Notification.permission === 'granted' ? 'on' : 'off';
  });
  const activerNotifs = async () => {
    try {
      const perm = await Notification.requestPermission();
      if (perm !== 'granted') { setNotif('denied'); return; }
      const reg = await navigator.serviceWorker.ready;
      const { data: k } = await axios.get(`${API}/push/public-key`);
      const pad = '='.repeat((4 - (k.publicKey.length % 4)) % 4);
      const b64 = (k.publicKey + pad).replace(/-/g, '+').replace(/_/g, '/');
      const raw = window.atob(b64);
      const appKey = Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
      const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: appKey });
      await axios.post(`${API}/push/subscribe`, { ...sub.toJSON(), email: data?.email || null });
      setNotif('on');
    } catch (e2) { alert('Activation impossible : ' + e2.message); }
  };

  // Iter 560 (Kamel) — bandeau INSISTANT tant que les notifications ne sont pas actives (revient à chaque visite, « plus tard » = cette session seulement)
  const [bandeauNotifs, setBandeauNotifs] = useState(() => { try { return sessionStorage.getItem('espace_bandeau_notifs') !== 'off'; } catch { return true; } });
  const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  const montrerBandeau = bandeauNotifs && notif !== 'on' && aVenir.length > 0 && !apercu && !!data;
  const plusTard = () => { setBandeauNotifs(false); try { sessionStorage.setItem('espace_bandeau_notifs', 'off'); } catch { /* ignore */ } };

  // Iter 561 — 📨 test push par l'adhérent lui-même
  const [pushTest, setPushTest] = useState('');
  const testerPush = async () => {
    setPushTest('envoi');
    try {
      const r = await axios.post(`${API}/espace-adherent/${token}/push-test`);
      setPushTest(r.data.sent ? `✅ Notification envoyée sur ${r.data.sent} appareil${r.data.sent > 1 ? 's' : ''} — elle doit apparaître dans quelques secondes. Rien reçu ? Vérifiez que les notifications sont autorisées pour l'appli dans les réglages du téléphone.` : (r.data.message || "⚠️ Aucun appareil abonné : touchez « Activer les notifications » puis réessayez."));
    } catch (e2) { setPushTest(e2.response?.data?.detail || 'Envoi impossible pour le moment.'); }
  };

  const prenom = ((aVenir[0] || fiches[0])?.voyageurs || [''])[0];
  const estTel = /^[\d\s+().-]{9,}$/.test(ident.trim());

  return (
    <div className="min-h-screen bg-[#FAF7F2] py-6 sm:py-10 px-3 sm:px-4 espace-adherent" data-testid="espace-adherent-page">
      <div className="max-w-2xl mx-auto space-y-4">
        <div className="bg-[#1E3A5F] text-white rounded-2xl p-5 sm:p-6">
          <p className="text-sm text-[#79c9ea] font-semibold">Rhône Alpes Amitié Voyages</p>
          <h1 className="text-2xl font-bold mt-1">👤 Mon Espace Adhérent</h1>
          <p className="text-sm mt-1 text-gray-200">{data && prenom ? `Bonjour ${prenom} ! ` : ''}{T('espace_sous_titre')}</p>
        </div>

        {!token && (
          <div className="bg-white rounded-2xl shadow-lg p-5 sm:p-6" data-testid="espace-demande-block">
            {sent ? (
              <div className="space-y-3">
                <p className="text-sm font-bold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-xl p-4" data-testid="espace-demande-ok">📬 {sent}</p>
                {!/Aucune fiche/.test(sent) && (
                  <>
                    <SpamNotice quoi="l'e-mail avec votre lien" testId="espace-lien-spam-notice" />
                    <p className="text-sm text-gray-800 bg-sky-50 border border-sky-200 rounded-xl p-3" data-testid="espace-lien-consigne">
                      {T('espace_lien_consigne')}
                    </p>
                    <details className="text-sm" data-testid="espace-code-details">
                      <summary className="cursor-pointer text-[#1E3A5F] font-semibold text-xs">Vous utilisez l'application installée sur votre téléphone ? Tapez plutôt le code à 6 chiffres reçu dans le même e-mail</summary>
                      <form onSubmit={validerCode} className="space-y-2 mt-2" data-testid="espace-code-form">
                        <input type="text" inputMode="numeric" autoComplete="one-time-code" maxLength={6} value={codeVal} onChange={e => setCodeVal(e.target.value.replace(/\D/g, ''))}
                          placeholder="● ● ● ● ● ●" data-testid="espace-code-input" className="w-full border-2 border-[#1E3A5F] rounded-lg px-3 py-3 text-center text-2xl font-bold tracking-[0.5em]" />
                        {codeErr && <p className="text-xs font-bold text-red-600" data-testid="espace-code-erreur">⚠️ {codeErr}</p>}
                        <button type="submit" disabled={codeBusy || codeVal.length !== 6} data-testid="espace-code-btn" className="w-full py-3 bg-[#1E3A5F] text-white font-bold rounded-xl hover:bg-[#2a4d7a] disabled:opacity-40">{codeBusy ? 'Vérification…' : '✅ Ouvrir mon espace avec le code'}</button>
                      </form>
                    </details>
                  </>
                )}
                <button type="button" onClick={() => { setSent(''); setCodeVal(''); }} className="text-xs text-[#1E3A5F] underline" data-testid="espace-recommencer">← Utiliser un autre e-mail ou téléphone</button>
              </div>
            ) : (
              <form onSubmit={demander} className="space-y-3" data-testid="espace-demande-form">
                <p className="text-sm text-gray-700" data-testid="espace-demande-intro">{T('espace_demande_intro')}</p>
                <p className="text-xs text-amber-900 bg-amber-50 border border-amber-200 rounded-xl p-2.5" data-testid="espace-pas-de-formulaire">
                  {T('espace_pas_de_formulaire')} <Link to="/inscription" className="underline font-bold">Remplissez d'abord le formulaire</Link>.
                </p>
                <input type="text" required autoComplete="username" inputMode="email" value={ident} onChange={e => setIdent(e.target.value)}
                  placeholder="votre-email@exemple.fr ou 06 12 34 56 78" data-testid="espace-email-input" className="w-full border-2 border-gray-300 focus:border-[#1E3A5F] rounded-xl px-3 py-3 text-base" />
                <button type="submit" disabled={busy || !ident.trim()} data-testid="espace-demander-btn" className="w-full py-3 bg-[#1E3A5F] text-white font-bold rounded-xl hover:bg-[#2a4d7a] disabled:opacity-40">
                  {busy ? 'Envoi…' : estTel ? '📩 Recevoir mon lien sur mon e-mail' : '📩 Recevoir mon lien'}
                </button>
                <p className="text-[11px] text-gray-400" data-testid="espace-memorisation-astuce">{T('espace_memorisation_astuce')}</p>
              </form>
            )}
          </div>
        )}

        {token && blocage && (
          <div className="bg-white border-2 border-amber-400 rounded-2xl p-5 shadow-lg space-y-3" data-testid="espace-blocage">
            <p className="text-lg font-extrabold text-amber-800">{blocage.code === 'en_reserve' ? '⏸️ Dossier mis en réserve' : '🚫 Aucun dossier actif'}</p>
            <p className="text-sm text-gray-800">{blocage.message}</p>
            {blocage.code === 'en_reserve' && (
              <p className="text-sm text-gray-700">{blocage.voyage ? <>Voyage concerné : <strong>{blocage.voyage}</strong>. </> : null}Votre place n'est pas perdue, mais votre dossier est <strong>en attente d'un échange avec nous</strong> (règlement, pièce, décision…). Un simple message suffit pour le réactiver.</p>
            )}
            <div className="flex flex-wrap gap-2 pt-1">
              <a href="https://wa.me/33660416218?text=Bonjour%2C%20mon%20dossier%20est%20en%20r%C3%A9serve%2C%20je%20souhaite%20le%20r%C3%A9activer." target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-sm font-bold px-4 py-2.5 rounded-xl bg-[#25D366] text-white" data-testid="espace-blocage-whatsapp">💬 WhatsApp 06 60 41 62 18</a>
              <a href="tel:+33660416218" className="inline-flex items-center gap-1.5 text-sm font-bold px-4 py-2.5 rounded-xl bg-[#1E3A5F] text-white" data-testid="espace-blocage-tel">📞 Appeler</a>
              <a href="mailto:rhoneamitie@gmail.com?subject=Mon%20dossier%20en%20r%C3%A9serve" className="inline-flex items-center gap-1.5 text-sm font-bold px-4 py-2.5 rounded-xl bg-gray-100 text-gray-800" data-testid="espace-blocage-mail">✉️ E-mail</a>
            </div>
          </div>
        )}
        {token && error && (error.startsWith('📶')
          ? <p className="text-sm font-bold text-amber-900 bg-amber-50 border border-amber-200 rounded-xl p-4" data-testid="espace-hors-ligne">{error} <button type="button" onClick={() => load()} className="underline" data-testid="espace-reessayer">Réessayer maintenant</button></p>
          : <p className="text-sm font-bold text-red-700 bg-red-50 border border-red-200 rounded-xl p-4" data-testid="espace-error">⚠️ {error} <Link to="/moi" className="underline">Redemander un code</Link></p>)}
        {token && !error && !blocage && !data && <p className="text-center text-gray-400 py-8">Chargement…</p>}
        {data && (
          <>
            {guide && <GuideBienvenue onClose={() => setGuide(false)} T={T} />}
            <p className="text-xs text-gray-500 flex items-center justify-between gap-2" data-testid="espace-email-label">
              <span>Espace de <strong>{data.email}</strong> · {fiches.length} inscription{fiches.length > 1 ? 's' : ''}</span>
              <span className="flex items-center gap-2 flex-shrink-0">
                <button onClick={() => setGuide(true)} data-testid="espace-revoir-guide-btn" className="min-h-[44px] px-1 text-xs font-bold text-[#1E3A5F] underline">❓ Guide</button>
                <button onClick={() => { oublierEspaceToken(); setTimeout(() => { window.location.href = '/moi'; }, 150); }} data-testid="espace-oublier-appareil-btn" className="min-h-[44px] px-1 text-xs text-gray-500 underline" title="Cet appareil mémorise votre espace. Cliquez pour l'oublier (appareil partagé…).">Changer d'espace</button>
              </span>
            </p>
            {fiches.filter(f => f.statut !== 'annulée').length >= 2 && <p className="text-xs font-bold text-amber-700 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2" data-testid="espace-fidelite-badge">⭐ Déjà {fiches.filter(f => f.statut !== 'annulée').length} voyages avec Rhône Alpes Amitié — merci pour votre fidélité !</p>}
            {(() => { // Iter 619 — 📌 bannière « X notes non lues » → saute directement aux notes
              const nl = aVenir.reduce((n, f) => n + (f.notes_voyage || []).filter(x => !x.lu_at).length, 0);
              if (!nl) return null;
              const f = aVenir.find(x => (x.notes_voyage || []).some(n => !n.lu_at));
              return (
                <button type="button" data-testid="espace-banniere-notes"
                  onClick={() => { const q = new URLSearchParams(window.location.search); q.set('notes', '1'); q.delete('note'); window.history.replaceState(null, '', `${window.location.pathname}?${q}`); allerChecklist('notes'); }}
                  className="w-full text-left flex items-center gap-3 rounded-2xl border-2 border-amber-400 bg-amber-50 px-4 py-3 shadow-sm hover:bg-amber-100 active:scale-[0.99] transition">
                  <span className="text-2xl" aria-hidden="true">📌</span>
                  <span className="flex-1 min-w-0">
                    <span className="block text-sm font-bold text-amber-950">{nl} note{nl > 1 ? 's' : ''} importante{nl > 1 ? 's' : ''} non lue{nl > 1 ? 's' : ''}{f ? ` — ${f.voyage}` : ''}</span>
                    <span className="block text-xs text-amber-800">Appuyez ici pour les lire maintenant, puis « ✅ J'ai bien lu »</span>
                  </span>
                  <span className="text-amber-700 font-bold">→</span>
                </button>
              );
            })()}
            {/* Iter 755 (Kamel, Turin J-1) — 🎫 QR d'embarquement tout en haut à J-1 / J0 / voyage en cours */}
            {(() => { const fq = ficheQrImminente(fiches); return fq ? <BandeauQrDepart f={fq} onOuvrirBus={() => { setFicheOuverte(fq.reg_id); setRubriqueFiche('bus'); setTimeout(() => document.getElementById(`fiche-${fq.reg_id}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150); }} /> : null; })()}
            <ChecklistDepart fiches={fiches} charteAt={data.charte_approuvee_at} onAller={allerChecklist} />
            {nbAChecker > 0 && (
              <button type="button" onClick={() => allerChecklist(aVenir.some(f => (f.notes_voyage || []).some(x => !x.lu_at)) ? 'notes' : aVenir.some(f => (f.questions || []).some(q => (q.reponses || []).some(r => r.valeur == null || r.valeur === '' || r.valeur === false))) ? 'questions' : aVenir.some(f => (f.rubriques_perso || []).some(r => !r.vue_at)) ? 'rubriques' : 'charte')}
                className="fixed left-2 bottom-[calc(4.75rem+env(safe-area-inset-bottom))] lg:bottom-auto lg:left-auto lg:top-20 lg:right-2 z-40 flex items-center gap-1.5 px-3 min-h-[40px] rounded-full bg-amber-500 text-white text-xs font-bold shadow-lg animate-pulse" data-testid="espace-badge-a-cocher">
                ⬜ <span className="lg:hidden">{nbAChecker} à cocher</span><span className="hidden lg:inline">Il vous reste {nbAChecker} chose{nbAChecker > 1 ? 's' : ''} à cocher</span>
              </button>
            )}
            {apercu && (
              <div className="bg-violet-700 text-white rounded-2xl p-3 shadow-lg text-sm" data-testid="espace-apercu-banner">
                <p className="font-bold">👁 Aperçu admin — vous voyez l'espace exactement comme {prenom || 'cet adhérent'} le voit.</p>
                <p className="text-xs opacity-90 mt-0.5">Lien valable 1 h, aucune ouverture comptée. 🔒 <strong>Lecture seule</strong> : cliquez partout sans risque, aucune action (case, charte, RDV, valise…) n'est enregistrée sur sa fiche.</p>
              </div>
            )}
            {bloque && (
              <div className="fixed bottom-[calc(4.75rem+env(safe-area-inset-bottom))] lg:bottom-4 left-1/2 -translate-x-1/2 z-[70] bg-violet-800 text-white text-sm font-bold px-4 py-2.5 rounded-full shadow-2xl" data-testid="espace-apercu-bloque">🔒 Aperçu en lecture seule — action non enregistrée</div>
            )}
            {montrerBandeau && (
              <div className="bg-amber-500 text-white rounded-2xl p-4 shadow-lg" data-testid="espace-bandeau-notifs">
                <div className="flex items-start gap-2">
                  <span className="relative flex h-3 w-3 mt-1 flex-shrink-0"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" /><span className="relative inline-flex rounded-full h-3 w-3 bg-white" /></span>
                  <div className="min-w-0 flex-1">
                    <p className="font-bold text-sm">📲 Installez l'appli pour recevoir les rappels du voyage</p>
                    <p className="text-xs opacity-95 mt-0.5">Heure du car, point de rendez-vous, programme du lendemain, changement de dernière minute : nous les envoyons en notification sur votre téléphone. {notif === 'denied' ? 'Vous avez refusé les notifications : réactivez-les dans les réglages de votre navigateur pour cette adresse.' : standalone && notif === 'off' ? "L'appli est installée : il ne reste qu'à activer les notifications 👇" : "2 minutes suffisent 👇"}</p>
                  </div>
                  <button type="button" onClick={plusTard} className="text-xs underline opacity-90 flex-shrink-0" data-testid="espace-bandeau-notifs-plus-tard">plus tard</button>
                </div>
                {standalone && notif === 'off' ? (
                  <button onClick={activerNotifs} data-testid="espace-bandeau-notifs-activer" className="mt-3 w-full py-3 rounded-xl bg-white text-amber-700 font-bold text-sm shadow">🔔 Activer les notifications maintenant</button>
                ) : notif !== 'denied' && (
                  <div className="mt-3 text-gray-900"><InstallAppBlock defaultOpen={!standalone} /></div>
                )}
                {standalone && notif === 'unsupported' && <p className="text-xs mt-2 opacity-95">Votre téléphone ne permet pas les notifications dans cette version : mettez-le à jour (iPhone : iOS 16.4 minimum).</p>}
              </div>
            )}
            {bienvenue && (
              <div className="bg-emerald-600 text-white rounded-2xl p-4 shadow-lg" data-testid="espace-bienvenue-payer">
                <p className="font-bold text-base">{T('bienvenue_titre', { prenom: prenom || '' }).replace(/\s{2,}/g, ' ')}</p>
                <p className="text-sm mt-1 opacity-95">Voici votre espace. <strong>Comment régler :</strong></p>
                <ol className="text-sm mt-1.5 space-y-1 list-decimal pl-5">
                  <li>Regardez <strong>« Payer à distance (CB, virement, chèques-vacances) »</strong> juste en dessous : {resteTotal > 0 ? <>il vous reste <strong>{Number(resteTotal).toLocaleString('fr-FR')} €</strong> (20 % à l'inscription suffisent pour valider).</> : 'rien à régler pour le moment.'}</li>
                  <li>Ouvrez <strong>« Payer à distance (CB, virement, chèques-vacances) »</strong> (déjà ouverte) : virement recommandé, carte bancaire, chèques-vacances papier par courrier (adresse sur demande par WhatsApp). Espèces : sur rendez-vous.</li>
                  <li>{T('bienvenue_etape3')}</li>
                </ol>
              </div>
            )}
            <p className="text-[11px] text-gray-500 px-1" data-testid="espace-consigne-accordeon">{T('consigne_accordeon')}</p>

            <h2 className="text-base font-bold text-[#1E3A5F] pt-1">🏠 Infos communes</h2>
            <Accordeon ouvert={commun} onChange={setCommun}>
              {/* Iter 580 (Kamel) — « Mon reste à payer » retiré des infos communes : le reste est dans chaque voyage (« Ma facture & mes règlements »). */}
              <Rubrique id="reglements" icone="💳" ton={resteTotal > 0 ? 'ambre' : 'vert'} titre="Payer à distance (CB, virement, chèques-vacances)" resume={resteTotal > 0 ? `Reste à payer ${Number(resteTotal).toLocaleString('fr-FR')} € · virement · carte · chèques · espèces sur RDV` : 'Tout est soldé ✅ · virement · carte · chèques · espèces sur RDV'}>
                {resteTotal > 0 && (
                  <div className="bg-amber-50 border border-amber-200 rounded-xl px-3 py-2 text-sm" data-testid="reglements-reste-resume">
                    {/* Iter 606 (Kamel — Ferrandes / Turin ×2) : la date distingue deux dossiers au même libellé */}
                    {aVenir.filter(f => f.restant > 0).map(f => <p key={f.reg_id} className="flex justify-between gap-2" data-testid={`reglement-ligne-${f.reg_id}`}><span className="truncate">{f.isAvion ? '✈️' : '🚌'} {f.voyage}{f.dates && <span className="text-gray-500 text-xs"> · {f.dates}</span>}</span><span className="font-bold text-amber-700 whitespace-nowrap"><Euros v={f.restant} /></span></p>)}
                    <p className="flex justify-between font-bold text-[#1E3A5F] border-t border-amber-200 mt-1 pt-1"><span>Total restant</span><span data-testid="reste-total"><Euros v={resteTotal} /></span></p>
                    <p className="text-[11px] text-gray-600 mt-1">{T('echeancier')}</p>
                  </div>
                )}
                <ReglementsDistance fiches={fiches} onRdv={() => ouvrirCommun('rdv')} />
              </Rubrique>
              <Rubrique id="rdv" icone="📅" ton="ambre" titre="Mon rendez-vous à la permanence" resume="Espèces ou chèques-vacances papier · Decathlon Bron · 10 minutes">
                <MonRendezVous token={token} fiches={fiches} nom={prenom} autoOuvrir={veutRdv} />
              </Rubrique>
              {/* Iter 580 — « Mes dossiers avion » déplacé dans chaque voyage (rubrique « Mon billet d'avion »). */}
              <Rubrique id="charte" icone="🤝" ton={data.charte_approuvee_at ? 'vert' : 'rouge'} titre="Ma charte du voyageur" resume={data.charte_approuvee_at ? 'Lue et approuvée ✅' : 'À lire et approuver (indispensable pour la convocation)'}>
                <CharteCollectif token={token} approuveeAt={data.charte_approuvee_at} onApprouvee={(at) => setData(d => ({ ...d, charte_approuvee_at: at }))} />
              </Rubrique>
              {data.rubriques?.sondages !== false && <Rubrique id="sondages" icone="📊" ton="bleu" titre="Sondages & avis" resume="Votre avis nous aide à organiser">
                <SondagesEspace token={token} />
                <p className="text-xs text-gray-500">Aucun sondage en cours ? Rien à faire ici pour l'instant. 😊</p>
              </Rubrique>}
              <Rubrique id="notifs" icone="🔔" ton={notif === 'on' ? 'vert' : 'gris'} titre="Mes notifications" resume={notif === 'on' ? 'Activées ✅' : notif === 'denied' ? 'Refusées dans le navigateur' : notif === 'unsupported' ? "Installez l'appli pour les recevoir" : 'Recevez rappels et infos de départ'}>
                <p className="text-xs text-gray-600" data-testid="espace-notifs-block">{notif === 'on' ? 'Activées ✅ — vous recevrez les rappels et infos de départ sur cet appareil.' : notif === 'denied' ? 'Refusées dans votre navigateur (réactivables dans ses réglages).' : notif === 'unsupported' ? "Sur cet appareil, les notifications ne fonctionnent qu'une fois l'appli installée (voir ci-dessous), puis activées depuis l'appli." : 'Recevez les rappels de paiement, horaires et infos de départ sur cet appareil.'}</p>
                {notif === 'off' && <button onClick={activerNotifs} data-testid="espace-notifs-btn" className="w-full py-3 rounded-xl bg-[#1E3A5F] text-white font-bold text-sm">🔔 Activer les notifications</button>}
                {notif === 'on' && (
                  <div>
                    <button onClick={testerPush} disabled={pushTest === 'envoi'} data-testid="espace-notifs-test-btn" className="w-full py-2.5 rounded-xl border-2 border-[#1E3A5F] text-[#1E3A5F] font-bold text-sm disabled:opacity-50">{pushTest === 'envoi' ? 'Envoi…' : "📨 M'envoyer une notification test"}</button>
                    {pushTest && pushTest !== 'envoi' && <p className="text-xs mt-1.5 text-gray-700" data-testid="espace-notifs-test-result">{pushTest}</p>}
                  </div>
                )}
                <InstallAppBlock />
              </Rubrique>
            </Accordeon>

            <h2 className="text-base font-bold text-[#1E3A5F] pt-2">🧳 Mes voyages {fiches.length > 1 && <span className="text-xs font-normal text-gray-500">— {fiches.length} inscriptions, appuyez sur un voyage pour l'ouvrir</span>}</h2>
            {fiches.length === 0 && <p className="text-sm text-gray-500 bg-white rounded-xl p-5 shadow">Aucune inscription trouvée pour cet email.</p>}
            {fiches.map(f => (
              <FicheVoyage key={f.reg_id} f={f} token={token} ouverte={ficheOuverte === f.reg_id}
                onToggle={() => { setFicheOuverte(ficheOuverte === f.reg_id ? null : f.reg_id); setRubriqueFiche(null); }}
                rubrique={ficheOuverte === f.reg_id ? rubriqueFiche : null} onRubrique={setRubriqueFiche}
                onRegler={() => ouvrirCommun('reglements')} rubriques={f.rubriques || data.rubriques || {}} onRubriqueVue={marquerRubriqueVue}
                dossierAvion={(data.dossiers_avion || []).find(d => d.reg_id === f.reg_id)} onDossierChange={load} />
            ))}

            <h2 className="text-base font-bold text-[#1E3A5F] pt-2">✨ Et aussi</h2>
            <Accordeon>
              {data.rubriques?.['prochains-voyages'] !== false && <Rubrique id="prochains-voyages" icone="🌍" ton="bleu" titre="Envie d'une prochaine aventure ?" resume="Nos prochains voyages + liste de diffusion">
                <ProchainsVoyages voyages={data.prochains_voyages || []} diffusionInscrit={!!data.diffusion_inscrit} token={token} />
              </Rubrique>}
              {data.rubriques?.partager !== false && <Rubrique id="partager" icone="💛" ton="rose" titre="Faire découvrir l'association" resume="Partagez à vos proches par WhatsApp ou e-mail">
                <PartagerRAAV token={token} partage={data.partage} />
              </Rubrique>}
            </Accordeon>

            <div className="bg-white rounded-2xl shadow p-4 text-center space-y-2" data-testid="espace-contact-block">
              <p className="text-sm font-bold text-[#1E3A5F]">💬 Une question ? L'assistant (en bas à droite) ou l'équipe</p>
              <div className="flex flex-wrap justify-center gap-2">
                <a href="https://wa.me/message/XTYPH2HUY3L6L1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-xs font-bold px-4 py-2 rounded-xl bg-[#25D366] text-white" data-testid="espace-contact-whatsapp">💬 WhatsApp 06 60 41 62 18</a>
                <a href="mailto:rhoneamitie@gmail.com" className="inline-flex items-center gap-1.5 text-xs font-bold px-4 py-2 rounded-xl bg-[#1E3A5F] text-white" data-testid="espace-contact-email">✉️ rhoneamitie@gmail.com</a>
              </div>
              <p className="text-[11px] text-gray-400">Rhône Alpes Amitié Voyages</p>
            </div>
          </>
        )}
      </div>
      {data && <AssistantChat token={token} prenom={(prenom || '').split(' ')[0]} voyage={(aVenir[0] || fiches[0])?.voyage || ''} />}
    </div>
  );
}
